/**
 * QR Code encoding mode values
 */
export enum ModeValue {
  TERMINATOR = 0,
  NUMERIC = 1,
  ALPHANUMERIC = 2,
  STRUCTURED_APPEND = 3,
  BYTE = 4,
  ECI = 5,
  KANJI = 6,
  FNC1_FIRST_POSITION = 7,
  FNC1_SECOND_POSITION = 8,
  HANZI = 9,
}
